export {
  openElement,
  toggleElement,
  closeElement,
}

function openElement(element) {
  element.setAttribute('open', '');
}

function toggleElement(element) {
  if (element.hasAttribute('open')) {
    closeElement(element);
  } else {
    openElement(element);
  }
}

function closeElement(element) {
  element.removeAttribute('open');
}
